import * as yup from "yup";
import { allowedDateFormats } from "./components/AssetColumn/Column";
import { allowedFunctions } from "./components/AssetFlag/AssetFlag.form";
import { ContactParentFolderKey } from "./utils/constant";
const urlPattern = /^(https?:\/\/)([\w.-]+)(:[0-9]+)?([/][\w\-./?%&=]*)?$/i;
export const tableSchema = yup.object({
  adminFeeStartingYear: yup
    .number()
    .required()
    .typeError("Admin Fee Starting  is Required"),
  assetManagement: yup
    .number()
    .required()
    .typeError("Asset Management is Required"),
  equityContribution: yup
    .number()
    .required()
    .typeError("Equity Contribution is Required"),
  assumedPercentageInveterWarranty: yup
    .number()
    .required()
    .typeError("Assumed Percentage Inveter Warranty is Required"),
  costPerExtendedInveterWarranty: yup
    .number()
    .required()
    .typeError("Cost Per Extended Inveter Warranty is Required"),
  developerDepositPayment1: yup
    .number()
    .required()
    .typeError("Developer Deposit Payment 1 is Required"),
  developerDepositPayment2: yup
    .number()
    .required()
    .typeError("Developer Deposit Payment 2 is Required"),
  developerDepositPayment3: yup
    .number()
    .required()
    .typeError("Developer Deposit Payment 3 is Required"),
  developerDevFee: yup
    .number()
    .required()
    .typeError("Developer Dev Fee is Required"),
  federalBonusDepreciation: yup
    .number()
    .required()
    .typeError("Federal Bonus Derreciation is Required"),
  federalBonusDepreciationPercent: yup
    .number()
    .required()
    .typeError("Federal Bonus Depreciation Percent is Required"),
  itcPercent: yup.number().required().typeError("ITC Percent is Required"),
  marginalFedTaxRate: yup
    .number()
    .required()
    .typeError("Marginal Fed Tax Rate is Required"),
  pPATerm: yup.number().required().typeError("PPA is Required"),
  percentagePropertyOwnerPurchases: yup
    .number()
    .required()
    .typeError("Percentage Property Owner Purchases is Required"),
  solarDegradation: yup
    .number()
    .required()
    .typeError("Solar Degradation is Required"),
  yrsAdminFeeEscalator: yup
    .number()
    .required()
    .typeError("Yrs Admin Fee Escalator is Required"),
  pandcCost: yup.number().required().typeError("PandC Cost is Required"),
  ppaPercentOfBillOfSale: yup
    .number()
    .required()
    .typeError("PPA % of Bill of Sale is Required"),
  ppaPercentOfTurnkey: yup
    .number()
    .required()
    .typeError("PPA % of Turnkey is Required"),
  turnkeyDC: yup.number().required().typeError("Turnkey $/W DC is Required"),
  percentOfPPAIncome: yup
    .number()
    .required()
    .typeError("Percent Of PPA Income is Required"),
  sizeKWDc: yup.number().required().typeError("Size KWDc  is Required"),
  reverseForExpenseInExcess: yup
    .number()
    .required()
    .typeError("Reverse For Expense In Excess is Required"),
  wholesaleReplecement: yup
    .number()
    .required()
    .typeError("Wholesale Replecement is Required"),
  replecementEscalator: yup
    .number()
    .required()
    .typeError("Replecement Escalator is Required"),
  feeCustomerDCPerYear: yup
    .number()
    .required()
    .typeError("Fee Customer DC per year is Required"),
  portfolioAve: yup.number().required().typeError("Portfolio Ave is Required"),
});
export const MacrsSchema = yup.object({
  macrsDRYear1: yup.number().required().typeError("Year 1 is Required*"),
  macrsDRYear2: yup.number().required().typeError("Year 2 is Required*"),
  macrsDRYear3: yup.number().required().typeError("Year 3 is Required*"),
  macrsDRYear4: yup.number().required().typeError("Year 4 is Required*"),
  macrsDRYear5: yup.number().required().typeError("Year 5 is Required*"),
  macrsDRYear6: yup.number().required().typeError("Year 6 is Required*"),
});
const depreciationRate = yup
  .number()
  .typeError("Depreciation rate must be a number")
  .min(0, "Depreciation rate must be at least 0%")
  .max(100, "Depreciation rate must be at most 100%");
export const stateSchema = yup.object({
  state: yup.string().required().typeError("State is Required*"),
  stateTaxRatePercent: yup
    .number()
    .typeError("Depreciation rate must be a number")
    .required("State Tax Percent is required*")
    .typeError("State Tax Percent is required*")
    .min(0, "State Tax Percent must be at least 0%")
    .max(100, "State Tax Percent cannot exceed 100%"),

  stateTaxRatePercentYrs7_20: yup
    .number()
    .typeError("Depreciation rate must be a number")
    .required("State Tax Rate Percent yrs is required*")
    .typeError("State Tax Rate Percent yrs is required*")
    .min(0, "State Tax Rate Percent yrs must be at least 0%")
    .max(100, "State Tax Rate Percent yrs cannot exceed 100%"),

  statePTEPaymentPercent: yup
    .number()
    .typeError("Depreciation rate must be a number")
    .required("State PTE Payment Percent is required*")
    .typeError("State PTE Payment Percent is required*")
    .min(0, "State PTE Payment Percent must be at least 0%")
    .max(100, "State PTE Payment Percent cannot exceed 100%"),

  stateBonusDepreciation: yup
    .string()
    .required()
    .typeError("State Bonus Depreciation is Required*"),
  stateDepreciation: yup
    .string()
    .required()
    .typeError("State Depreciation is Required*"),
  stateRevenueSpread: yup.string(),
  depRateY1: depreciationRate,
  depRateY2: depreciationRate,
  depRateY3: depreciationRate,
  depRateY4: depreciationRate,
  depRateY5: depreciationRate,
  depRateY6: depreciationRate,
  lossLimitations: yup.number().typeError("Loss Limitations must be a number"),
  fedDepAddBack: yup.number().typeError("Fed Dep Add Back must be a number"),
});
export const resetSchema = yup.object({
  password: yup
    .string()
    .min(8, "Password should be 8 characters long")
    .required("Password is required*")
    .label("Password"),
  confirmPassword: yup
    .string()
    .required("Confirm Password is required")
    .oneOf([yup.ref("password")], "Passwords must match")
    .label("Confirm Password"),
});
export const subAdminSchema = yup.object({
  name: yup.string().required("Name is required").label("Name"),
  password: yup
    .string()
    .min(8, "Password should be 8 characters long")
    .required("Password is required*")
    .label("Password"),
});
export const reportInputSchema = yup.object({
  equalityContribution: yup.string().when("grossIncome", {
    is: (grossIncome) => !grossIncome,
    then: () => yup.string().required("Equity Contribution is required*"),
  }),
  grossIncome: yup.string().optional(),
  stateId: yup.string().required("State is required*"),
  estFederalTaxRate: yup
    .string()
    .required("Estimated Federal Tax Rate is required*"),
});

export const replySchema = yup.object({
  reply: yup.string().trim().required("Reply is required"),
});

export const zohoIdSchema = yup.object({
  zohoId: yup.string().trim().required("Zoho Id is required"),
});

export const contactOwner = yup.object({
  userId: yup.string().trim().required("User Id is required"),
  ownerName: yup.string().trim(),
  ownerRole: yup.string().trim(),
  ownerPhone: yup.string().trim(),
  ownerEmail: yup.string().trim(),
  subOwnerName: yup.string().trim(),
  subOwnerRole: yup.string().trim(),
  subOwnerEmail: yup.string().trim(),
  subOwnerPhone: yup.string().trim(),
  calendlyLink: yup.string().trim(),
});

export const proformaUser = yup.object({
  userName: yup.string().trim().required("User Name is required"),
  pin: yup.number().typeError("Pin is required").required("Pin is required"),
  contactGroup: yup
    .string()
    .test("required", "Contact Group is required", function (value, context) {
      if (context.options.context?.isExternal && !value) {
        return this.createError({
          message: "Contact Group is required",
        });
      }
      return true;
    }),
});

export const contactGroup = yup.object({
  contactGroupName: yup
    .string()
    .trim()
    .required("Contact group name is required"),
  folderId: yup.string().trim().required("Folder ID is required"),
  developerDevFee: yup
    .string()
    .trim()
    .required("Developer dev Fee is required"),
  itcPercent: yup.string().trim().required("ITC Percent is required"),
  email: yup
    .string()
    .trim()
    .test(
      "valid-email-format",
      "Enter valid email(s) separated by a space",
      (value) => {
        if (!value || value.trim() === "") return true; // Skip validation if empty
        return /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/.test(
          value
        );
      }
    )
    .test(
      "unique-emails",
      "Email(s) must be unique (case-insensitive)",
      (value) => {
        if (!value || value.trim() === "") return true; // Skip validation if empty
        const emails = value.split(/\s+/); // Split emails by space
        const normalizedEmails = emails.map((email) => email.toLowerCase()); // Normalize to lowercase
        const uniqueEmails = new Set(normalizedEmails); // Use Set to find duplicates
        return uniqueEmails.size === normalizedEmails.length; // Check for duplicates
      }
    ),
  isJvTrancheAllowed: yup
    .boolean()
    .required("Please select whether JV Tranche is allowed"),
  jvTrancheUserZohoId: yup
    .string()
    .nullable()
    .when("isJvTrancheAllowed", {
      is: true,
      then: (schema) =>
        schema.required(
          "JV Purchaser Contact ID is required when JV Tranche is allowed"
        ),
      otherwise: (schema) => schema.nullable(),
    }),
});

export const emailValidationSchema = yup.object({
  email: yup
    .string()
    .trim()
    .matches(
      /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/,
      "Enter valid email(s) separated by a space"
    )
    .required("Email(s) is required")
    .test(
      "unique-emails",
      "Email(s) must be unique (case-insensitive)",
      (value) => {
        if (!value) return true;
        const emails = value.split(/\s+/);
        const normalizedEmails = emails.map((email) => email.toLowerCase());
        const uniqueEmails = new Set(normalizedEmails);
        return uniqueEmails.size === normalizedEmails.length;
      }
    ),
});

const optionalNumber = yup
  .number()
  .nullable()
  .transform((value, originalValue) => (originalValue === "" ? null : value));

export const productionReportSchema = yup.object({
  // These fields are excluded from the form but included in the final submission
  recordId: yup.string().optional(),
  recordIdDeal: yup.string().optional(),
  assetId: yup.string().optional(),

  // These fields are included in the form and validated
  dealName: yup.string().trim(),
  monthYear: yup
    .string()
    .trim()
    .matches(/^(0[1-9]|1[0-2])-\d{4}$/, "Format must be MM-YYYY")
    .required("Month and Year is required"),
  measurementType: yup.string().trim(),
  actualEstimatedPercent: optionalNumber.typeError(
    "Actual / Estimated % must be a number"
  ),
  actualProduction: optionalNumber.typeError(
    "Actual Production must be a number"
  ),
  netEstimate: optionalNumber.typeError("Net Estimate must be a number"),
  electricityCharged: optionalNumber.typeError(
    "Electricity Charged must be a number"
  ),
  electricityDischarged: optionalNumber.typeError(
    "Electricity Discharged must be a number"
  ),
  pvTotalActualEnergy: optionalNumber.typeError(
    "PV: Total Actual Energy must be a number"
  ),
  totalForecastedEnergy: optionalNumber.typeError(
    "Total Forecasted Energy must be a number"
  ),
  actualEstimatedStorage: optionalNumber.typeError(
    "Actual/Estimated % Storage must be a number"
  ),
});

export const trancheForm = (totalRemainder) =>
  yup
    .object()
    .shape({
      assetDealSource: yup.string().required("Asset Provider is required"),

      assetType: yup.string().required("Asset type is required"),

      minPvRequired: yup
        .number()
        .transform(function (value, originalValue) {
          return originalValue === "" ? undefined : value;
        })
        .typeError("PV percent must be a number")
        .min(0, "PV percent must be at least 0%")
        .max(100, "PV percent cannot exceed 100%")
        .nullable(),

      minStorageRequired: yup
        .number()
        .transform(function (value, originalValue) {
          return originalValue === "" ? undefined : value;
        })
        .typeError("Storage percent must be a number")
        .min(0, "Storage percent must be at least 0%")
        .max(100, "Storage percent cannot exceed 100%")
        .nullable(),

      itcPercent: yup
        .number()
        .typeError("ITC percent must be a number")
        .required("ITC percent is required")
        .min(0, "ITC percent must be at least 0%")
        .max(100, "ITC percent cannot exceed 100%"),

      states: yup.array().of(yup.string()).min(1, "Select at least one state"),

      internalMarkupPercent: yup
        .number()
        .typeError("Internal Markup must be a number")
        .required("Internal Markup percent is required")
        .min(0, "Internal Markup percent must be at least 0%")
        .max(100, "Internal Markup percent cannot exceed 100%"),

      affiliateMarkupPercent: yup
        .number()
        .typeError("Affiliate Markup must be a number")
        .required("Affiliate Markup percent is required")
        .min(0, "Affiliate Markup percent must be at least 0%")
        .max(100, "Affiliate Markup percent cannot exceed 100%"),

      equityContribution: yup
        .number()
        .typeError("Equity Contribution must be a number")
        .required("Equity Contribution is required")
        .min(0, "Equity Contribution must be at least 0")
        .max(
          totalRemainder,
          `Equity Contribution cannot exceed ${totalRemainder}`
        ),
    })
    .test(
      "total-percentage",
      "Sum of PV + Storage cannot exceed 100%",
      function (values) {
        const { minPvRequired, minStorageRequired } = values;

        const pv = minPvRequired || 0;
        const storage = minStorageRequired || 0;

        if (pv + storage > 100) {
          return this.createError({
            path: "minStorageRequired",
            message: "Sum of PV + Storage cannot exceed 100%",
          });
        }

        return true;
      }
    );

const validationSchema = yup
  .object({
    required: yup.boolean().required("Asset validation is required."),
    dateFormat: yup
      .array()
      .of(yup.string().oneOf(allowedDateFormats, "Invalid date format"))
      .notRequired(),
  })
  .optional();

export const assetColumnSchema = yup.object().shape({
  label: yup
    .string()
    .trim()
    .required("Column name is required")
    .min(1, "Column name cannot be empty")
    .matches(/^[a-zA-Z0-9 ]+$/, "Special characters are not allowed."), // special character not allowed
  csvLabel: yup
    .array()
    .of(yup.string().nullable()) // Allow strings, null, or undefined in the array
    .optional() // Make the field optional (can be undefined)
    .nullable() // Allow null for the entire array
    .transform((value, originalValue) => {
      // Handle case where input is a single string or malformed data
      if (typeof originalValue === "string") {
        return [originalValue]; // Convert single string to array
      }
      // Filter out null/undefined/empty strings if desired
      return value ? value.filter((item) => item != null && item !== "") : [];
    }),
  zohoLabel: yup
    .mixed()
    .optional()
    .transform((value, originalValue) => {
      if (
        Array.isArray(value) &&
        value.length === 1 &&
        typeof value[0] === "string"
      ) {
        return value[0].replace(/^"|"$/g, "");
      }
      if (typeof value === "string") {
        return value.replace(/^"|"$/g, "");
      }
      return null;
    })
    .nullable()
    .test("is-string", "Zoho label must be a string", (value) => {
      return value === undefined || value === null || typeof value === "string";
    }),
  dataType: yup
    .string()
    .oneOf(
      ["string", "number", "boolean", "date"],
      "Data type must be one of: string, number, boolean"
    )
    .required("Data type is required"),
  validation: validationSchema,
  defaultValue: yup.string().trim().optional(),
  isFormula: yup.boolean().optional(),
  formula: yup.string().optional(),
  dependencies: yup.array().of(yup.string()).optional(),
  zohoDateFormat: yup
    .string()
    .oneOf(allowedDateFormats, "Invalid date format")
    .notRequired(),
  isCritical: yup.boolean().optional(),
  fileName: yup
    .string()
    .max(100, "File name must be at most 100 characters")
    .optional(),
  APIKey: yup // New field validation
    .string()
    .trim()
    .max(500, "API key must be at most 100 characters")
    .optional(),
  zohoKeysLabel: yup
    .array()
    .of(yup.string().nullable()) // Allow strings, null, or undefined in the array
    .optional() // Make the field optional (can be undefined)
    .nullable() // Allow null for the entire array
    .transform((value, originalValue) => {
      // Handle case where input is a single string or malformed data
      if (typeof originalValue === "string") {
        return [originalValue]; // Convert single string to array
      }
      // Filter out null/undefined/empty strings if desired
      return value ? value.filter((item) => item != null && item !== "") : [];
    }),
  hideFromPortal: yup.boolean().optional(),
});

export const apiKeySchema = yup.object().shape({
  name: yup.string().required("Name is required"),
});

export const assetLogsEmailSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required("Email is required")
    .email("Invalid email format"),
});

export const assetFlagsSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  flag: yup.string().required("Formula is required"),
  // .test("only-allowed-functions", "Contains invalid function", (value) => {
  //   if (!value) return false;
  //   // Extract words (functions)
  //   const matches = value.match(/[A-Z]+/gi) || [];
  //   return matches.every((fn) =>
  //     allowedFunctions.includes(fn.toUpperCase())
  //   );
  // })
  // .matches(/^[=A-Za-z0-9<>\+\-\*\/\(\),"\s]+$/, "Invalid characters"),
  description: yup.string().nullable(),
});

export const trancheSchema = yup.object().shape({
  trancheName: yup.string().trim().required("Tranche Name is required"),
  clientName: yup.string().nullable().notRequired(),
  groupType: yup.string().nullable().notRequired(),
  entityName: yup.string().nullable().notRequired(),
  entityFullAddress: yup.string().nullable().notRequired(),
  trancheContactId: yup.string().nullable().notRequired(),
});

export const sectionSchema = yup.object({
  name: yup
    .string()
    .transform((value) => (value ? value.trim() : ""))
    // ✅ letters, numbers, and spaces only
    .matches(/^[A-Za-z0-9 ]*$/, "Only letters, numbers, and spaces are allowed")
    .when([], {
      is: (val) => !val || val.length === 0,
      then: (schema) => schema,
      otherwise: (schema) => schema.required("Section name is required"),
    }),
});

// Validation schema
export const baseUrlSchema = yup.object().shape({
  url: yup
    .string()
    .matches(
      /^(https?:\/\/localhost(:\d+)?|https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/.*)?$/,
      "Enter a valid URL"
    )
    .required("URL is required"),
});

export const APIFormSchema = yup.object({
  name: yup.string().required("Name is required"),
  url: yup.string().url("Invalid URL").required("URL is required"),
  method: yup.string().oneOf(["POST", "PUT"]).required("Method is required"),
});

export const assetApiSchema = yup.object({
  name: yup.string().trim().required("API name is required"),
  url: yup.string(),
  method: yup.string().oneOf(["POST", "PUT"]).required("Method is required"),
  url: yup
    .string()
    .required("URL is required")
    .matches(
      urlPattern,
      "Please enter a valid URL (e.g., https://example.com or https://api.example.com/v1/resource)"
    )
    .test(
      "noInvalidChars",
      "URL contains invalid characters",
      (value) => !/[<>{}|\\\^`]/.test(value || "")
    ),
  headers: yup
    .array()
    .of(
      yup.object({
        key: yup.string().nullable(),
        value: yup.string().nullable(),
        enabled: yup.boolean().default(true),
      })
    )
    .optional(),
  params: yup
    .array()
    .of(
      yup.object({
        colId: yup.string().nullable(),
        json_key: yup.string().required("Param JSON key is required"),
      })
    )
    .optional(),
  bodyFields: yup
    .array()
    .of(
      yup.object({
        colId: yup.string().nullable(),
        json_key: yup.string().required("Body JSON key is required"),
      })
    )
    .optional(),
  conditionVariables: yup
    .array()
    .of(
      yup.object({
        _id: yup.string().required("Condition column ID is required"),
        label: yup.string().required("Condition label is required"),
      })
    )
    .optional(),
});

export const proformaSchema = yup.object().shape({
  proformaName: yup.string().required("Proforma Name is required"),
  scenarioName: yup.string().required("Scenario Name is required"),
  adjustedGrossIncome: yup
    .number()
    .typeError("Adjusted Gross Income must be a number")
    .required("Adjusted Gross Income is required"),
  lossLimitation: yup
    .string()
    .typeError("Loss Limitation must be a number")
    .required("Loss Limitation is required"),
  contactGroup: yup.string().required("Contact Group is required"),
  federalRevenueSpread: yup
    .string()
    .required("Federal Revenue Spread is required"),
  state: yup.string().required("State is required"),
  federalMarginalTaxRate: yup
    .number()
    .typeError("Federal Marginal Tax Rate must be a number")
    .required("Federal Marginal Tax Rate is required"),
  internalMarkup: yup
    .number()
    .typeError("Internal Markup must be a number")
    .required("Internal Markup is required")
    .max(100, "Internal Markup cannot exceed 100%")
    .min(0, "Internal Markup must be at least 0%"),
  affiliateMarkup: yup
    .number()
    .typeError("Affiliate Markup must be a number")
    .required("Affiliate Markup is required")
    .max(100, "Affiliate Markup cannot exceed 100%")
    .min(0, "Affiliate Markup must be at least 0%"),
  affiliateMarkupEC: yup
    .number()
    .typeError("Affiliate Markup % EC must be a number")
    .required("Affiliate Markup % EC is required")
    .max(100, "Affiliate Markup % EC cannot exceed 100%")
    .min(0, "Affiliate Markup % EC must be at least 0%"),

  clientName: yup.string().required("Client Name is required"),
  clientEmailAddress: yup.string().email("Invalid email").optional(),
  equityContribution: yup
    .number()
    .typeError("Equity Contribution must be a number")
    .required("Equity Contribution is required"),
  itcTarget: yup
    .number()
    .typeError("ITC % Target must be a number")
    .required("ITC % Target is required")
    .max(100, "ITC % Target cannot exceed 100%")
    .min(0, "ITC % Target must be at least 0%"),

  proformaGDrive: yup
    .string()
    .url("Must be a valid URL")
    .required("Proforma GDrive link is required"),
  clientProformaUrl: yup
    .string()
    .url("Must be a valid URL")
    .required("Client Proforma URL is required"),
});

export const contactDocumentSchema = yup.object().shape({
  section: yup
    .object()
    .shape({
      value: yup.string(),
      label: yup.string(),
    })
    .nullable()
    .when("parentFolderKey", {
      is: (parentFolderKey) =>
        parentFolderKey?.value ===
        ContactParentFolderKey.LLC_FORMATION_DOCUMENTS,
      then: (schema) => schema.nullable().notRequired(),
      otherwise: (schema) =>
        schema.required("Section is required").shape({
          value: yup.string().required("Section is required"),
          label: yup.string().required(),
        }),
    }),
  file: yup
    .mixed()
    .required("File is required")
    .test("file", "A valid file is required", (value) => value instanceof File),
  parentFolderKey: yup.mixed().nullable(),
});

export const partnerDocumentSchema = yup.object().shape({
  fileName: yup.string().trim().required("File Name is required"),

  file: yup
    .mixed()
    .nullable()
    .test("fileType", "A valid file is required", (value) => {
      if (!value) return true;
      return value instanceof File;
    }),

  link: yup
    .string()
    .trim()
    .nullable()
    .url("Enter a valid URL")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Upload a file or provide a link"),
    }),
});

export const pandCDocumentSchema = yup.object().shape({
  reportName: yup.string().trim().required("Report Name is required"),
  fileName: yup.string().trim().required("File Name is required"),
  section: yup
    .object()
    .shape({
      value: yup.string().required("Section is required"),
      label: yup.string().required(),
    })
    .required("Section is required"),
  file: yup
    .mixed()
    .required("File is required")
    .test("file", "A valid file is required", (value) => value instanceof File),
});

export const correctionMessageSchema = yup.object().shape({
  message: yup
    .string()
    .trim()
    .required("Message is required.")
    .max(1000, "Message cannot exceed 1000 characters.")
    .test(
      "not-empty",
      "Message cannot be empty or just whitespace.",
      (value) => value && value.trim().length > 0
    ),
});

export const divisorLookupSchema = yup.object().shape({
  prepaymentPercent: yup
    .number()
    .typeError("Must be a number")
    .positive("Must be greater than 0")
    .required("Required"),

  projectState: yup.string().required("Required"),

  itcPercent: yup
    .number()
    .typeError("Must be a number")
    .min(1, "Minimum 1%")
    .max(100, "Maximum 100%")
    .required("Required"),

  isApolloHomePower: yup.boolean().required("Required"),

  divisorThrough93025Tranche: yup
    .number()
    .typeError("Must be a number")
    .positive("Must be greater than 0")
    .required("Required"),

  divisorStarting10725Tranche: yup
    .number()
    .typeError("Must be a number")
    .positive("Must be greater than 0")
    .required("Required"),
});

export const profileSchema = yup.object({
  name: yup.string().required("Name is required"),
});

export const passwordSchema = yup.object({
  currentPassword: yup.string().required("Current password is required"),

  newPassword: yup
    .string()
    .min(8, "Must be at least 8 characters")
    .required("New password is required"),

  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "Password must match with new password")
    .required("Confirm password is required"),
});

export const productionReportV2ColumnSchema = yup.object().shape({
  label: yup.string().trim().required("Column name is required"),
  importLabel: yup
    .array()
    .of(yup.string().nullable())
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return [originalValue];
      }
      return value ? value.filter((item) => item != null && item !== "") : [];
    })
    .min(1, "At least one import label is required")
    .required("Import label is required"),
  dataType: yup
    .string()
    .oneOf(["string", "number", "boolean", "date"], "Invalid data type")
    .required("Data type is required"),
  exportLabel: yup.string().trim().optional().nullable(),
  isExportable: yup.boolean().optional(),
  isVisible: yup.boolean().optional(),
  isEditable: yup.boolean().optional(),
  isRequired: yup.boolean().optional(),
});

export const trancheAPISchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  url: yup
    .string()
    .required("URL is required")
    .matches(
      urlPattern,
      "Please enter a valid URL (e.g., https://example.com or https://localhost:3030)"
    ),
  method: yup.string().oneOf(["POST", "PUT"]).required("Method is required"),
  apiEndpointId: yup.string().nullable().notRequired(),
  conditionalColumnIds: yup.array().of(yup.string()).optional(),
});

export const resourcesSchema = yup.object({
  title: yup.string().trim().required("Title is required"),
  type: yup.string().required("Type is required"),
  input: yup.mixed().optional(),
  icon: yup.mixed().optional(),
  message: yup.string().optional(),
});

export const createPowerBiSectionSchema = yup.object().shape({
  sectionName: yup.string().required("Section name is required").trim(),
});

export const addKnowledgeGapSchema = yup.object({
  question: yup
    .string()
    .trim()
    .required("Topic is required")
    .min(5, "Topic must be at least 5 characters")
    .max(1000, "Topic cannot exceed 1000 characters"),
});

export const addUrlSchema = yup.object({
  name: yup.string().trim().required("Name is required"),
  url: yup.string().trim().required("URL is required").url("Please enter a valid URL"),
  overwrite: yup.boolean(),
  ingest: yup.boolean(),
});

export const addYoutubeSchema = yup.object({
  name: yup.string().trim().required("Name is required"),
  url: yup
    .string()
    .trim()
    .required("YouTube URL is required")
    .url("Please enter a valid URL")
    .matches(
      /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)[\w-]+(\S*)?$/i,
      "Please enter a valid YouTube URL",
    ),
  overwrite: yup.boolean(),
  ingest: yup.boolean(),
});

export const addGoogleDriveSchema = yup.object({
  name: yup.string().trim().required("Name is required").max(200, "Name must be 200 characters or less"),
  folderId: yup.string().trim().required("Folder ID is required"),
});
